import { useLocation, useNavigate } from "react-router-dom";
import { useUrlQueries } from "./useUrlQueries";

export const useAuthRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getQuery, removeQuery } = useUrlQueries();

  const redirectToLogin = () => {
    const redirectUrl = `${location.pathname}${location.search}${location.hash}`;
    const loginUrl = `/login?redirect=${encodeURIComponent(redirectUrl)}`;
    navigate(loginUrl, { replace: true });
  };

  /**
   * We should use location.href instead of navigate to clean RTK Query in-memory cache
   */
  const redirectToLoginAfterLogout = () => {
    window.location.href = "/login";
  };

  const redirectToStoresAfterLogin = () => {
    const originalRedirect = getQuery("redirect");
    if (originalRedirect) {
      if (originalRedirect.match(/^\/stores\/[^]+/)) {
        redirectToFinalDestination();
      } else {
        navigate(`/stores?redirect=${originalRedirect}`, { replace: true });
      }
    } else {
      navigate("/stores", { replace: true });
    }
  };
  const redirectToFinalDestination = () => {
    const finalRedirect = getQuery("redirect");
    if (finalRedirect) {
      removeQuery("redirect");
      try {
        const decodedUrl = decodeURIComponent(finalRedirect);
        navigate(decodedUrl, { replace: true });
      } catch (error) {
        console.error("Error decoding redirect URL:", error);
        navigate("/", { replace: true });
      }
    } else {
      navigate("/", { replace: true });
    }
  };

  return {
    redirectToLogin,
    redirectToStoresAfterLogin,
    redirectToFinalDestination,
    redirectToLoginAfterLogout,
  };
};
